import { FilePreviewProps } from 'screens/blaze/Home/components/Catalogue/components/FilePreview/Types'
import Styles from './FileCardContainer.module.scss'
import { Skeleton } from 'components/Skeleton/Skeleton'
import { Title } from 'screens/blaze/Home/components/Catalogue/components/CategoryCard/Title'

export const FileCardLoader = ({ file }: FilePreviewProps) => (
  <div className={Styles.loaderContainer}>
    <div className={Styles.loader}>
      <Skeleton active paragraph={false} />
      <Skeleton active paragraph={false} />
      <Skeleton active paragraph={false} />
      <Skeleton active paragraph={false} />
      <Skeleton active paragraph={false} />
      <Skeleton active paragraph={false} />
      <Skeleton active paragraph={false} />
      <Skeleton active paragraph={false} />
      <Skeleton active paragraph={false} />
      <Skeleton active paragraph={false} />
    </div>
    <Title>{file.title}</Title>
  </div>
)
